import { DATA_CACHE_SIZE, FILE_LOCKING_EXTENSIONS, } from '@lucidlink/sdk';
async function buildContext(getter, settings) {
    for (const fullName of settings) {
        if (fullName === DATA_CACHE_SIZE) {
            const [result, ..._] = await getter(DATA_CACHE_SIZE);
            return {
                sizeBefore: result.value,
            };
        }
        else if (fullName === FILE_LOCKING_EXTENSIONS) {
            const [result, ..._] = await getter(FILE_LOCKING_EXTENSIONS);
            return {
                extensionsBefore: result.value,
            };
        }
        else {
            continue;
        }
    }
    return {};
}
export async function buildGlobalSetContext(settings, filespaceClient) {
    if (!filespaceClient) {
        return;
    }
    const settingNames = settings.map((s) => s.fullName);
    const getter = async (name) => {
        return await filespaceClient.globalSettingManager().get([name]);
    };
    return buildContext(getter, settingNames);
}
export async function buildGlobalUnsetContext(settings, filespaceClient) {
    if (!filespaceClient) {
        return;
    }
    const getter = async (name) => {
        return await filespaceClient.globalSettingManager().get([name]);
    };
    return buildContext(getter, settings);
}
